/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agency_Pointthreebold2Inputs */

const ja_home_agency_pointthreebold2 = /** @type {(inputs: Home_Agency_Pointthreebold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちのミッションは、ゲームを通じて日本と世界をつなぐことです。`)
};

const en_home_agency_pointthreebold2 = /** @type {(inputs: Home_Agency_Pointthreebold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting Japan to the World with Games.`)
};

/**
* | output |
* | --- |
* | "Connecting Japan to the World with Games." |
*
* @param {Home_Agency_Pointthreebold2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_agency_pointthreebold2 = /** @type {((inputs?: Home_Agency_Pointthreebold2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agency_Pointthreebold2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_agency_pointthreebold2(inputs)
	return en_home_agency_pointthreebold2(inputs)
});
export { home_agency_pointthreebold2 as "home_agency_pointThreeBold" }